import { Label, Message, Popup } from 'semantic-ui-react';
import { getChannelOption } from './helper';
import React from 'react';

export function renderText(text, limit) {
  if (text.length > limit) {
    return text.slice(0, limit - 3) + '...';
  }
  return text;
}

export function renderGroup(group) {
  if (group === '') {
    return (
      <span style={{
        display: 'inline-block',
        padding: '3px 8px',
        borderRadius: 6,
        background: '#f5f5f5',
        color: '#6b7280',
        fontSize: 12,
        fontWeight: 500,
        border: '1px solid rgba(0,0,0,0.12)',
      }}>default</span>
    );
  }
  let groups = group.split(',');
  groups.sort();
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
      {groups.map((g, i) => {
        let cfg;
        if (g === 'vip' || g === 'pro') {
          cfg = { bg: 'rgba(250,204,21,0.14)', color: '#d97706', border: 'rgba(250,204,21,0.3)' };
        } else if (g === 'svip' || g === 'premium') {
          cfg = { bg: '#fef2f2', color: '#dc2626', border: 'rgba(220,38,38,0.3)' };
        } else {
          cfg = { bg: '#f5f5f5', color: '#6b7280', border: 'rgba(0,0,0,0.12)' };
        }
        return (
          <span key={i} style={{
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: 6,
            background: cfg.bg,
            color: cfg.color,
            fontSize: 12,
            fontWeight: 500,
            border: `1px solid ${cfg.border}`,
          }}>{g}</span>
        );
      })}
    </div>
  );
}

// renderChannelLimit 渲染用户的渠道访问限制标签。
// channelIds/channelNames 为逗号分隔字符串，都为空表示不限制（显示"全部"标签）。
export function renderChannelLimit(channelIds, channelNames) {
  const hasIds = channelIds && channelIds !== '';
  const hasNames = channelNames && channelNames !== '';
  if (!hasIds && !hasNames) {
    return (
      <span style={{
        display: 'inline-block',
        padding: '2px 7px',
        borderRadius: 6,
        background: 'rgba(34,197,94,0.12)',
        color: '#16a34a',
        fontSize: 11,
        fontWeight: 500,
        border: '1px solid rgba(34,197,94,0.3)',
      }}>全部</span>
    );
  }
  const tags = [];
  if (hasIds) {
    channelIds.split(',').filter(Boolean).forEach((id) => {
      tags.push({ text: `#${id}`, type: 'id' });
    });
  }
  if (hasNames) {
    channelNames.split(',').filter(Boolean).forEach((name) => {
      tags.push({ text: name, type: 'name' });
    });
  }
  // 超过 3 个时只显示前 2 个 + "等N个"，完整列表用 Popup
  const maxShow = 2;
  const showTags = tags.slice(0, maxShow);
  const restCount = tags.length - showTags.length;
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 3 }}>
      {showTags.map((tag, i) => (
        <span key={i} style={{
          display: 'inline-block',
          padding: '2px 7px',
          borderRadius: 6,
          background: tag.type === 'id' ? 'rgba(59,130,246,0.12)' : 'rgba(168,85,247,0.12)',
          color: tag.type === 'id' ? '#2563eb' : '#9333ea',
          fontSize: 11,
          fontWeight: 500,
          border: `1px solid ${tag.type === 'id' ? 'rgba(59,130,246,0.3)' : 'rgba(168,85,247,0.3)'}`,
        }}>{tag.text}</span>
      ))}
      {restCount > 0 && (
        <Popup
          content={tags.map((t) => t.text).join(', ')}
          trigger={
            <span style={{
              display: 'inline-block',
              padding: '2px 7px',
              borderRadius: 6,
              background: '#f5f5f5',
              color: '#6b7280',
              fontSize: 11,
              fontWeight: 500,
              border: '1px solid rgba(0,0,0,0.12)',
              cursor: 'pointer',
            }}>+{restCount}</span>
          }
          hoverable
        />
      )}
    </div>
  );
}

export function renderNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

export function renderQuota(quota, t, precision = 2) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = parseFloat(
    localStorage.getItem('quota_per_unit') || '1'
  );

  if (displayInCurrency) {
    const amount = (quota / quotaPerUnit).toFixed(precision);
    return t('common.quota.display_short', { amount });
  }

  return renderNumber(quota);
}

export function renderQuotaWithPrompt(quota, t) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = parseFloat(
    localStorage.getItem('quota_per_unit') || '1'
  );

  if (displayInCurrency) {
    const amount = (quota / quotaPerUnit).toFixed(2);
    return ` (${t('common.quota.display', { amount })})`;
  }

  return '';
}

const colorConfigs = [
  { bg: '#fef2f2', color: '#dc2626', border: 'rgba(220,38,38,0.3)' },  // red
  { bg: '#fff7ed', color: '#ea580c', border: 'rgba(234,88,12,0.3)' },  // orange
  { bg: 'rgba(250,204,21,0.14)', color: '#d97706', border: 'rgba(250,204,21,0.3)' },  // yellow
  { bg: 'rgba(132,204,22,0.14)', color: '#4d7c0f', border: 'rgba(132,204,22,0.3)' },  // olive
  { bg: '#f0fdf4', color: '#16a34a', border: 'rgba(22,163,74,0.3)' },  // green
  { bg: 'rgba(45,212,191,0.14)', color: '#0f766e', border: 'rgba(45,212,191,0.3)' },  // teal
  { bg: 'rgba(0,0,0,0.08)', color: '#18181b', border: 'rgba(0,0,0,0.16)' },  // blue
  { bg: 'rgba(0,0,0,0.04)', color: '#18181b', border: 'rgba(0,0,0,0.12)' },  // violet
  { bg: '#faf5ff', color: '#9333ea', border: 'rgba(147,51,234,0.3)' },  // purple
  { bg: '#fdf2f8', color: '#db2777', border: 'rgba(219,39,119,0.3)' },  // pink
  { bg: 'rgba(217,119,87,0.14)', color: '#d98a57', border: 'rgba(217,119,87,0.3)' },  // brown
  { bg: '#f5f5f5', color: '#6b7280', border: 'rgba(156,163,175,0.3)' },  // grey
  { bg: 'rgba(229,231,235,0.10)', color: '#18181b', border: 'rgba(229,231,235,0.2)' },  // black
];

export function renderColorLabel(text) {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  let index = Math.abs(hash % colorConfigs.length);
  const cfg = colorConfigs[index];
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 8px',
      borderRadius: 6,
      background: cfg.bg,
      color: cfg.color,
      fontSize: 12,
      fontWeight: 500,
      border: `1px solid ${cfg.border}`,
      maxWidth: 150,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}>
      {text}
    </span>
  );
}

export function renderChannelTip(channelId) {
  let channel = getChannelOption(channelId);
  if (channel === undefined || channel.tip === undefined) {
    return <></>;
  }
  return (
    <Message>
      <div dangerouslySetInnerHTML={{ __html: channel.tip }}></div>
    </Message>
  );
}
